import React from 'react';

import appointmentModel, { BookAppointment } from 'components/appointments/Book';
import { MCButton, Spinner } from 'components/basic';
import { lang } from 'src/helpers';
import { BASE_ICONS } from 'components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import { Doctor } from 'components/appointments/Book/Doctor';
import { Patient } from 'components/appointments/Book/Patient';
import { AddPatient } from 'components/appointments/Book/AddPatient';
import { AddPatientDetail } from 'components/appointments/Book/AddPatientDetail';
import { BookSlots } from 'components/appointments/Book/Slots';
import { BookInfo } from 'components/appointments/Book/Info';
import { BookOffice } from 'components/appointments/Book/Office';
import { models, STEPS } from 'components/slotSchedule/model';

const model = models[STEPS.BOOK];

export class Book extends BookAppointment {
  componentDidMount() {
    appointmentModel.subscribe(this.subscription);
    model.subscribe(this.subscription);
    this.init().then();
  }

  componentWillUnmount() {
    appointmentModel.unsubscribe(this.subscription);
    model.unsubscribe(this.subscription);
  }

  getSlotProp = () => {
    return model.state.slot;
  };

  getParamsProp = () => {
    return model.state.params;
  };

  render() {
    if (this.state.loading)
      return (
        <div className={'mc-flex mc-m-auto'}>
          <Spinner />
        </div>
      );

    const { onPrev, onDone } = this.props;

    return (
      <>
        <div className='mc-modal-header mc-flex'>
          {onPrev && (
            <MCButton
              width={40}
              iconname={BASE_ICONS.BACK_ARROW}
              primary
              onClick={onPrev}
              style={{ marginVertical: -10 }}
            />
          )}
          <div className='mc-popup-title'>{lang.t(LANG_CONST.buttons.add_new_appointment)}</div>
        </div>
        <div className='mc-modal-body mc-grow mc-flex-15-col'>
          <div className={'mc-grow mc-flex-20-col mc-book-doctor'}>
            <div className={'mc-tab-box'}>
              <Doctor {...this.props} onBack={onPrev} />
              <Patient
                {...this.props}
                onBack={onPrev}
                loadBeforeSlotStep={this.loadBeforeSlotStep}
              />
              <AddPatient
                {...this.props}
                onBack={onPrev}
                loadBeforeSlotStep={this.loadBeforeSlotStep}
              />
              <AddPatientDetail
                {...this.props}
                onBack={onPrev}
                loadBeforeSlotStep={this.loadBeforeSlotStep}
              />
              <BookSlots
                {...this.props}
                onBack={onPrev}
                onCalendarRef={(r) => (this.calendarRef = r)}
              />
              <BookInfo {...this.props} onBack={onPrev} onDone={onDone} />
              <BookOffice {...this.props} onBack={onPrev} onDone={onDone} />
            </div>
          </div>
        </div>
      </>
    );
  }
}
